/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboPostawsauthrolearnPostAWSAuthRoleARNResult
 */
export interface JumboPostawsauthrolearnPostAWSAuthRoleARNResult {
    /**
     * 
     * @type {string}
     * @memberof JumboPostawsauthrolearnPostAWSAuthRoleARNResult
     */
    userAccountID?: string;
}

/**
 * Check if a given object implements the JumboPostawsauthrolearnPostAWSAuthRoleARNResult interface.
 */
export function instanceOfJumboPostawsauthrolearnPostAWSAuthRoleARNResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboPostawsauthrolearnPostAWSAuthRoleARNResultFromJSON(json: any): JumboPostawsauthrolearnPostAWSAuthRoleARNResult {
    return JumboPostawsauthrolearnPostAWSAuthRoleARNResultFromJSONTyped(json, false);
}

export function JumboPostawsauthrolearnPostAWSAuthRoleARNResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboPostawsauthrolearnPostAWSAuthRoleARNResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userAccountID': !exists(json, 'userAccountID') ? undefined : json['userAccountID'],
    };
}

export function JumboPostawsauthrolearnPostAWSAuthRoleARNResultToJSON(value?: JumboPostawsauthrolearnPostAWSAuthRoleARNResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userAccountID': value.userAccountID,
    };
}

